import { cn } from "../lib/utils";
import { useReducedMotion } from "framer-motion";
import React, { useLayoutEffect, useRef, useState } from "react";
const SCROLL_SPEED_PX_PER_SECOND = 50;
function hoverScrollStyle(overflowPx) {
  return {
    "--scroll-distance": `${overflowPx}px`,
    "--scroll-duration": `${overflowPx / SCROLL_SPEED_PX_PER_SECOND * 1000}ms`
  };
}
/**
 * @cc [owner:adrsimon,label:react;product] scrolls-only-when-truncated
 * The text MUST scroll forward only while an ancestor `group` is hovered and the text overflows
 * its box. When the hover ends it snaps back to its start. Without overflow, or under reduced
 * motion, it MUST render as a plain ellipsis-truncated line.
 */
export function HoverScrollText({
  className,
  text
}) {
  const shouldReduceMotion = useReducedMotion();
  const textRef = useRef(null);
  const [overflowPx, setOverflowPx] = useState(0);
  useLayoutEffect(() => {
    const element = textRef.current;
    if (!element) {
      return;
    }
    const measure = () => setOverflowPx(element.scrollWidth - element.clientWidth);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [text]);
  const canScroll = overflowPx > 0 && !shouldReduceMotion;
  return /*#__PURE__*/React.createElement("span", {
    className: cn("block min-w-0 overflow-hidden", className)
  }, /*#__PURE__*/React.createElement("span", {
    ref: textRef,
    className: cn("block truncate", canScroll && cn("group-hover:overflow-visible group-hover:text-clip", "group-hover:translate-x-[calc(var(--scroll-distance)*-1)]",
    // Transition only while hovered so the text snaps back when the hover ends.
    "group-hover:transition-transform group-hover:delay-300 group-hover:duration-(--scroll-duration) group-hover:ease-linear")),
    style: canScroll ? hoverScrollStyle(overflowPx) : undefined
  }, text));
}
//# sourceMappingURL=HoverScrollText.js.map